import { HTMLAttributes } from "react"

export function EmptyImage(props: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            {...props}
            className={`flex items-center justify-center bg-gray-200 text-gray-600 text-2 italic font-bold lg:text-6 ${props.className || ''}`}>
           <span className="base-text-ellipsis">Image is empty</span>
        </div>
    )
}